<script setup lang="ts">
import { computed } from 'vue';
import { useQuasar } from 'quasar';

import type { CustomPageDto, Locales } from '@/services/types/api.types';
import { useCommunityStore } from '@/stores';
import ReorderableTable from '@/components/ReorderableTable.vue';
import CustomPageEditDialog from '@/components/CustomPageEditDialog.vue';
import { useI18n } from 'vue-i18n';

// PROPS
const props = defineProps<{
  languageEnabled: Locales[];
}>();

const $q = useQuasar();
const { t } = useI18n();
const communityStore = useCommunityStore();

const communityId = communityStore.community?.id ?? -1;
// const currentCommunity = communityStore.communities.find(c => c.id === communityId);

const columns = computed(() => [
  { name: 'slug', label: t('custom_page.fields.slug'), field: (row: CustomPageDto) => row.slug, align: 'left' },
  {
    name: 'type',
    label: 'Type',
    field: (row: CustomPageDto) => customPagesType.value.find((x) => x.value === row.type)?.label,
    align: 'left',
  },
]);

const community = computed(() => communityStore.communities.find((c) => c.id === communityId));
const customPagesType = computed(() => communityStore.getCustomPageTypes());

const handleRowClick = (row: CustomPageDto) => {
  $q.dialog({
    component: CustomPageEditDialog,
    componentProps: {
      customPage: row,
      languageEnabled: props.languageEnabled,
    },
  });
};
</script>

<template>
  <div class="custom-pages">
    <reorderable-table
      :rows="community!.customPages"
      :columns="columns"
      :title="t('community.tabs.customPage')"
      itemKey="id"
      @row-click="handleRowClick"
      :disableOrderable="true"
      :disableAddButton="true"
      :disableDeleteButton="true"
    />
  </div>
</template>
<style lang="scss">
.custom-pages {
  padding: 16px;
}
</style>
